<template
    ><div>
        <div class="row">
            <div class="col-xs-12 col-md-8">
                <div
                    class="card card-builder form-create-panel config-card-block"
                >
                    <!-- draggable area -->
                    <draggable
                        :list="formData"
                        group="people"
                        class="dragArea list-group"
                        @change="moveField()"
                    >
                        <!-- :class="[
                                field.isLocked
                                    ? 'form-field-types draggable-fields pointer-none'
                                    : 'form-field-types draggable-fields',
                            ]" -->
                        <div
                            v-for="(field, index) in formData"
                            :key="index"
                            class="form-field-types draggable-fields"
                        >
                            <!-- field move icon -->
                            <span class="move-icon"
                                ><i class="icon-move"></i
                            ></span>
                            <!-- field type icon -->
                            <span><i :class="field.icon"></i></span>
                            <p>{{ field.label }}</p>

                            <div
                                :class="[
                                    !field.isLocked ? 'enabled' : 'disabled',
                                    'action-items',
                                ]"
                            >
                                <!-- settings icon -->
                                <i
                                    class="action-icons icon-settings"
                                    @click="
                                        addOrUpdateField(
                                            field.type,
                                            'modify',
                                            field,
                                            index
                                        )
                                    "
                                ></i>
                                <!-- field locked icon -->
                                <i
                                    v-if="field.isLocked"
                                    class="action-icons icon-change-password"
                                ></i>
                                <!-- delete icon -->
                                <i
                                    v-if="!field.isLocked"
                                    class="change-password icon-trash"
                                    @click="removeField(index)"
                                ></i>
                            </div>
                        </div>
                    </draggable>

                    <!-- When data is loading -->
                    <base-table-spinner
                        v-if="formData.length == 0 && showPageLoader"
                    ></base-table-spinner>
                    <!-- When record not found -->
                    <base-no-record-found
                        v-if="formData.length == 0 && !showPageLoader"
                    ></base-no-record-found>
                </div>
            </div>
            <!-- Fields Type-->
            <div class="col-xs-12 col-md-4">
                <div
                    class="component-panel-open"
                    @click="openComponent ^= true"
                >
                    <i class="icon-plus"></i>
                </div>
                <div
                    class="card card-builder field-type-panel with-shadow config-card-block"
                    :class="openComponent == true ? 'show-Component' : ''"
                >
                    <h4>Components</h4>
                    <div
                        class="component-panel-close"
                        @click="openComponent ^= true"
                    >
                        <i class="icon-delete"></i>
                    </div>
                    <div>
                        <div
                            v-for="(field, index) in fieldType"
                            :key="index"
                            class="form-field-types"
                        >
                            <div
                                @click="
                                    addOrUpdateField(field.type, 'add', field)
                                "
                            >
                                <span><i :class="field.icon"></i></span>
                                <p>{{ field.label }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <add-heading-popup
            :title="titleChange"
            :button-text="buttonText"
            :route="route"
            :current-field="currentField"
            :index="index"
        ></add-heading-popup>

        <add-text-field-popup
            :title="titleChange"
            :button-text="buttonText"
            :route="route"
            :current-field="currentField"
            :index="index"
            :type="type"
            :icon="icon"
        ></add-text-field-popup>

        <add-select-field-popup
            :title="titleChange"
            :button-text="buttonText"
            :route="route"
            :current-field="currentField"
            :index="index"
            :type="type"
            :icon="icon"
        ></add-select-field-popup>

        <remove-field-popup
            :list="formData"
            :index="index"
        ></remove-field-popup>
    </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import addHeadingPopup from '@/components/popups/form-builder/AddHeadingPopup.vue'
import addTextFieldPopup from '@/components/popups/form-builder/AddTextFieldPopup.vue'
import addSelectFieldPopup from '@/components/popups/form-builder/AddSelectFieldPopup.vue'
import removeFieldPopup from '@/components/popups/form-builder/RemoveFieldPopup.vue'

export default {
    components: {
        draggable,
        addHeadingPopup,
        addTextFieldPopup,
        addSelectFieldPopup,
        removeFieldPopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            isFieldAdded: false,
            showPageLoader: false,
            currentField: {},
            index: null,
            type: '',
            icon: '',
            query: {
                dataSegmentId: null,
                section: null,
            },
            route: 'setup_profile',
            titleChange: null,
            buttonText: null,
            navWidth: true,
            listVal: null,
            listDropdown: false,
            openComponent: false,
            menuListing: [
                {
                    anchorLink: '/configuration/form-builder/setup-profile',
                    menuLabel: 'Setup Profile',
                },
                {
                    anchorLink: '/configuration/form-builder/account',
                    menuLabel: 'Account Info',
                },
            ],
            fieldType: [
                {
                    icon: 'icon-heading',
                    label: 'Heading',
                    type: 'heading',
                },
                {
                    icon: 'icon-text-field',
                    label: 'Text Field',
                    type: 'text-field',
                },
                {
                    icon: 'icon-text-area',
                    label: 'Text Area',
                    type: 'text-area',
                },
                {
                    icon: 'icon-calendar',
                    label: 'Date Field',
                    type: 'date-picker',
                },
                {
                    icon: 'icon-select-field',
                    label: 'Dropdown / Select Field',
                    type: 'dropdown',
                },
                {
                    icon: 'icon-radio',
                    label: 'Radio Button Group',
                    type: 'radio',
                },
                {
                    icon: 'icon-checkbox',
                    label: 'Checkbox Group',
                    type: 'checkbox',
                },
            ],
            formData: [],
        }
    },

    computed: {
        ...mapGetters(['user', 'dataSegmentId', 'formBuilderList', 'loading']),
    },

    watch: {
        loading(val) {
            this.showPageLoader = val
        },

        formBuilderList(value) {
            this.getRecords(JSON.parse(JSON.stringify(value)))
        },

        dataSegmentId(value) {
            if (value) {
                this.formData = []
                this.$parent.previewForm = false
                this.route = this.$route.meta.formBuilder
                this.getFormBuilderList()
            }
        },

        formData: {
            handler(value) {
                if (value) {
                    this.moveField()

                    localStorage.setItem(
                        'previewFormData',
                        JSON.stringify(value)
                    )

                    let formBuilderData = {
                        dataSegmentId: this.dataSegmentId,
                        section: this.route,
                        fields: value,
                    }

                    this.$store.commit(
                        'setFormBuilderData',
                        JSON.parse(JSON.stringify(formBuilderData))
                    )
                }
            },
            deep: true,
        },

        $route() {
            if (this.$parent.previewForm) {
                this.formData = []
                this.route = this.$route.meta.formBuilder
                this.getRecords()
            } else {
                this.formData = []
                this.route = this.$route.meta.formBuilder
                this.getFormBuilderList()
            }
        },
    },

    mounted() {
        localStorage.setItem('formBuilderChangeDetect', false)

        if (this.$parent.previewForm) {
            this.formData = []
            this.route = this.$route.meta.formBuilder
            this.getRecords()
        } else {
            this.formData = []
            this.route = this.$route.meta.formBuilder
            this.getFormBuilderList()
        }
    },

    methods: {
        async getFormBuilderList() {
            if (this.dataSegmentId) {
                this.query.dataSegmentId = this.dataSegmentId
                this.query.section = this.route
                await this.$store.dispatch('getFormBuilderList', this.query)
            }
        },
        async getRecords(data) {
            if (this.$parent.previewForm) {
                let previewFormData = localStorage.getItem('previewFormData')
                    ? JSON.parse(localStorage.getItem('previewFormData'))
                    : []
                if (previewFormData.length > 0) {
                    for (
                        var index = 0;
                        index < previewFormData.length;
                        index++
                    ) {
                        if (previewFormData[index].type == 'heading') {
                            previewFormData[index].icon = 'icon-heading'
                        }
                        if (previewFormData[index].type == 'text-field') {
                            previewFormData[index].icon = 'icon-text-field'
                        }
                        if (
                            previewFormData[index].type == 'text-field' ||
                            previewFormData[index].type == 'phone-number'
                        ) {
                            previewFormData[index].icon = 'icon-text-field'
                        }
                        if (previewFormData[index].type == 'text-area') {
                            previewFormData[index].icon = 'icon-text-area'
                        }
                        if (
                            previewFormData[index].type == 'date-picker' ||
                            previewFormData[index].type ==
                                'identity-document-expiry'
                        ) {
                            previewFormData[index].icon = 'icon-calendar'
                        }
                        if (
                            previewFormData[index].type == 'dropdown' ||
                            previewFormData[index].type == 'list' ||
                            previewFormData[index].type == 'identity-type' ||
                            previewFormData[index].type == 'nationality' ||
                            previewFormData[index].type == 'work-type' ||
                            previewFormData[index].type == 'industry' ||
                            previewFormData[index].type == 'country' ||
                            previewFormData[index].type == 'tax-id'
                        ) {
                            previewFormData[index].icon = 'icon-select-field'
                        }
                        if (previewFormData[index].type == 'radio') {
                            previewFormData[index].icon = 'icon-radio'
                        }
                        if (previewFormData[index].type == 'checkbox') {
                            previewFormData[index].icon = 'icon-checkbox'
                        }
                        if (previewFormData[index].type == 'multi-select') {
                            previewFormData[index].icon = 'icon-blacklist'
                        }

                        previewFormData[index].title =
                            previewFormData[index].label

                        this.formData.push(previewFormData[index])
                    }
                }
            } else {
                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].type == 'heading') {
                            data[i].icon = 'icon-heading'
                        }
                        if (
                            data[i].type == 'text-field' ||
                            data[i].type == 'phone-number'
                        ) {
                            data[i].icon = 'icon-text-field'
                        }
                        if (data[i].type == 'text-area') {
                            data[i].icon = 'icon-text-area'
                        }
                        if (
                            data[i].type == 'date-picker' ||
                            data[i].type == 'identity-document-expiry'
                        ) {
                            data[i].icon = 'icon-calendar'
                        }
                        if (
                            data[i].type == 'list' ||
                            data[i].type == 'dropdown' ||
                            data[i].type == 'identity-type' ||
                            data[i].type == 'nationality' ||
                            data[i].type == 'work-type' ||
                            data[i].type == 'industry' ||
                            data[i].type == 'country' ||
                            data[i].type == 'tax-id'
                        ) {
                            data[i].icon = 'icon-select-field'
                        }

                        if (data[i].type == 'radio') {
                            data[i].icon = 'icon-radio'
                        }
                        if (data[i].type == 'checkbox') {
                            data[i].icon = 'icon-checkbox'
                        }
                        if (data[i].type == 'multi-select') {
                            data[i].icon = 'icon-blacklist'
                        }

                        data[i].title = data[i].label

                        this.formData.push(data[i])
                    }
                }
            }
            this.formData = _.orderBy(this.formData, 'sequenceNumber', 'asc')
        },

        removeField(index) {
            this.index = index
            this.$bvModal.show('remove-field')
        },

        moveField() {
            if (this.formData.length > 0) {
                for (var i = 0; i < this.formData.length; i++) {
                    if (this.formData[i].section === this.route) {
                        this.formData[i].sequenceNumber = i + 1
                    }
                }
            }
        },

        addOrUpdateField(val, val2, currentField, index) {
            if (val == 'heading') {
                if (val2 == 'add') {
                    this.titleChange = 'Add Heading'
                    this.buttonText = 'Add'
                }
                if (val2 == 'modify') {
                    this.titleChange = 'Modify Heading'
                    this.buttonText = 'Update'
                    this.currentField = JSON.parse(JSON.stringify(currentField))
                    this.index = index
                }
                this.$bvModal.show('add-heading-popup')
            }
            if (
                val == 'text-field' ||
                val == 'text-area' ||
                val == 'date-picker'
            ) {
                if (val2 == 'add') {
                    this.titleChange = 'Add ' + currentField.label
                    this.type = val
                    this.icon = currentField.icon
                }
                if (val2 == 'modify') {
                    this.titleChange = 'Modify ' + currentField.label
                    this.buttonText = 'Update'
                    this.currentField = JSON.parse(JSON.stringify(currentField))
                    this.index = index
                    this.type = val
                    this.icon = currentField.icon
                }
                this.$bvModal.show('add-text-field-popup')
            }
            if (val == 'dropdown' || val == 'radio' || val == 'checkbox') {
                if (val2 == 'add') {
                    this.titleChange = 'Add ' + currentField.label
                    this.buttonText = 'Add'
                    this.type = val
                    this.icon = currentField.icon
                }
                if (val2 == 'modify') {
                    this.titleChange = 'Modify ' + currentField.label
                    this.buttonText = 'Update'
                    this.currentField = JSON.parse(JSON.stringify(currentField))
                    this.index = index
                    this.type = val
                    this.icon = currentField.icon
                }
                this.$bvModal.show('add-select-field-popup')
            }
        },
    },
}
</script>
